<template>
  <div class="m-2 md:m-8 flex relative" id="main">
    <div
      class="xs:w-8 sm:w-24 md:w-48 w-64 flex-none bg-cover rounded-t lg:rounded-t-none rounded-b lg:rounded-l text-center overflow-hidden shadow-xl"
      :style="{ backgroundImage: `url(${student.profileImg})` }"
      :title="student.fullname"
    ></div>
    <div class="bg-red-700 p-1 mt-8 mb-8"></div>
    <div
      class="border-r border-b border-l border-gray-400 lg:border-l-0 lg:border-t lg:border-gray-400 bg-white rounded-b lg:rounded-b-none lg:rounded-r p-4 flex flex-col justify-between leading-normal w-54 self-center mt-8 mb-8 l-8 shadow-xl"
    >
      <router-link :to="`/profiles/${student.id}`">
        <div class="mb-1 m-auto">
          <div class="text-gray-900 font-bold text-2xl text-center">
            {{ student.fullname }}
          </div>
          <div class="text-red-700 text-sm text-center">
            {{ student.nicknames.join(", ") }}
          </div>
        </div>
      </router-link>
      <hr class="m-4 mb-2" />
      <div class="mb-2">
        <p class="text-red-700 text-sm font-semibold">Years Active</p>
        <p class="text-gray-700 text-xs">{{ student.years.join(" - ") }}</p>
      </div>
      <div class="mb-2">
        <p class="text-red-700 text-sm font-semibold">Enjoyed</p>
        <p class="text-gray-700 text-xs">
          {{ student.extracurriculars.join(", ") }}
        </p>
      </div>
      <div class="mb-2">
        <p class="text-red-700 text-sm font-semibold">Fondly remembers</p>
        <p class="text-gray-700 text-xs">{{ student.teachers.join(", ") }}</p>
      </div>
      <div class="mb-2">
        <p class="text-red-700 text-sm font-semibold">Keeps in touch with</p>
        <p class="text-gray-700 text-xs">{{ student.friends.join(", ") }}</p>
      </div>
      <div class="mb-2">
        <p class="text-red-700 text-sm font-semibold">Record of misconduct</p>
        <p class="text-gray-700 text-xs">{{ student.misconduct }}</p>
      </div>
      <hr class="m-4 mb-2" />
      <div class="text-center">
        <button class="m-auto" @click="openButtonUrl(student.social.fb)">
          <img
            src="https://img.icons8.com/material/24/000000/facebook-new.png"
          />
        </button>
        <button class="m-auto" @click="openButtonUrl(student.social.insta)">
          <img
            class="red-700"
            src="https://img.icons8.com/material/24/000000/instagram-new--v1.png"
          />
        </button>
      </div>
    </div>

    <div
      class="absolute inset-x-64 bottom-0 text-white bg-red-700 p-2 .break-words sm:w-32 w-48 mb-8 ml-16 rounded-l text-sm"
    >
      <router-link :to="`/profiles/${student.id}`">
        {{ student.bio }}</router-link
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "Profile",
  methods: {
    openButtonUrl(url) {
      window.open(url);
    },
  },
  props: {
    student: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
img {
  -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
  filter: grayscale(100%);
}
</style>




// WEBPACK FOOTER //
// src/components/profiles/Profile.vue